module.exports = __webpack_public_path__ + "static/media/PPR.f34a1390.svg";